"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_temporal_polyfill_1 = require("@mishakanai/js-temporal-polyfill");
var F_Instant_1 = __importDefault(require("./F_Instant"));
var F_Instant_Add = /** @class */ (function () {
    /** @hidden */
    function F_Instant_Add(instant, dir) {
        if (dir === void 0) { dir = 1; }
        this.instant = instant;
        this.dir = dir;
        this.minutes = this.minutes.bind(this);
        this.hours = this.hours.bind(this);
        this.days = this.days.bind(this);
        this.weeks = this.weeks.bind(this);
        this.months = this.months.bind(this);
        this.years = this.years.bind(this);
        this.getZonedDateTime = this.getZonedDateTime.bind(this);
    }
    /** @hidden */
    F_Instant_Add.prototype.getZonedDateTime = function (timeZone) {
        if (timeZone === void 0) { timeZone = js_temporal_polyfill_1.Temporal.Now.timeZoneId(); }
        return this.instant.toZonedDateTimeISO(js_temporal_polyfill_1.Temporal.TimeZone.from(timeZone));
    };
    F_Instant_Add.prototype.minutes = function (minutes) {
        return new F_Instant_1.default(this.instant.add({
            minutes: minutes * this.dir,
        }));
    };
    F_Instant_Add.prototype.hours = function (hours) {
        return new F_Instant_1.default(this.instant.add({
            hours: hours * this.dir,
        }));
    };
    F_Instant_Add.prototype.days = function (days) {
        return new F_Instant_1.default(this.getZonedDateTime()
            .add({
            days: days * this.dir,
        })
            .toInstant());
    };
    F_Instant_Add.prototype.weeks = function (weeks) {
        return new F_Instant_1.default(this.getZonedDateTime()
            .add({
            weeks: weeks * this.dir,
        })
            .toInstant());
    };
    F_Instant_Add.prototype.months = function (months, timeZone) {
        return new F_Instant_1.default(this.getZonedDateTime(timeZone)
            .add({
            months: months * this.dir,
        })
            .toInstant());
    };
    F_Instant_Add.prototype.years = function (years, timeZone) {
        return new F_Instant_1.default(this.getZonedDateTime(timeZone)
            .add({
            years: years * this.dir,
        })
            .toInstant());
    };
    return F_Instant_Add;
}());
exports.default = F_Instant_Add;
//# sourceMappingURL=F_Instant_Add.js.map